import Cookies from 'js-cookie'

const TokenKey = 'Admin-Common-Token'


export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function getStep() {
  return Cookies.get('step')
}

export function setStep(step) {
  return Cookies.set("step", step)
}

export function setRoleId(roleId) {
  return Cookies.set("roleId", roleId)
}

export function getRoleId() {
  return Cookies.get("roleId")
}

// 获取角色前缀（0:搭建商 builder, 其他:主场 homecourt）
export function getRolePrefix() {
  return getRoleId() == "0" ? "builder" : "homecourt"
}

export function getUserInfo() {
  return JSON.parse(localStorage.getItem("userInfo")||"{}")
}

export function setUserInfo(data) {
  return localStorage.setItem("userInfo", JSON.stringify(data||{}))
}

// 设置 venueCode
export function setVenueCode(venueCode) {
  return Cookies.set("venueCode", venueCode)
}

// 获取 venueCode
export function getVenueCode() {
  return Cookies.get("venueCode")
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function clearAllCookies() {
  console.log('清除所有 Cookies')
  // 获取所有 Cookie 的名称
  const cookieNames = Object.keys(Cookies.get());

  // 遍历所有 Cookie 名称并删除它们
  cookieNames.forEach(name => {
      Cookies.remove(name);
  });
}

// companyName
export function setCompanyName(companyName) {
  return localStorage.setItem("companyName", companyName)
}

export function getCompanyName() {
  return localStorage.getItem("companyName")
}